function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from "react";
import GenericNodeCollection from "./core/GenericNodeCollection";
export var JSONLD = function JSONLD(props) {
  var json = null;

  if (props.children) {
    var _Object$assign;

    var ChildClass = props.children.type;

    var _props$children$props = props.children.props,
        children = _props$children$props.children,
        type = _props$children$props.type,
        schema = _objectWithoutPropertiesLoose(_props$children$props, ["children", "type"]);

    var childClassInstance = new ChildClass(props.children.props);
    var firstChild = childClassInstance.getJSON(schema);
    json = childClassInstance instanceof GenericNodeCollection ? Object.assign({
      "@context": "https://schema.org/"
    }, (_Object$assign = {}, _Object$assign[type] = firstChild, _Object$assign)) : Object.assign({
      "@context": "https://schema.org/"
    }, firstChild);
  }

  return React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(json)
    }
  });
};
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default JSONLD;